import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("video", {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.stopped && !_vm.loading,
          expression: "!stopped && !loading",
        },
      ],
      ref: "video",
      staticStyle: {
        width: "100%",
        "max-height": "480px",
        "object-fit": "contain",
      },
      attrs: { autoplay: "true" },
    }),
    _vm.loading
      ? _c(
          "div",
          { staticClass: "d-flex flex-column" },
          [
            _c(VProgressCircular, {
              staticClass: "mx-auto my-16",
              attrs: { indeterminate: "", color: "primary", size: 100 },
            }),
            _c("div", [_vm._v("Loading Camera...")]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }